<template lang="pug">
  .main_container_button_panel
    .btn_container_button_panel
      .left_button_panel
        button.save_button_panel(v-if="save" @click="saveState")
          //- v-icon.i(name="check" scale="0.8" style="margin-right: 5px")
          span Сохранить
        button.close_button_panel(v-if="closeWithOutChanges" @click="closeState")
          //- v-icon.i(name="times" scale="0.8" style="margin-right: 5px")
          span(style="font-size: 14px; font-weight: bold; margin-right: 5px") ✖
          span Закрыть без изменений
        button.close_button_panel(v-if="close" @click="closeState")
          //- v-icon.i(name="times" scale="0.8" style="margin-right: 3px")
          span(style="font-size: 14px; font-weight: bold; margin-right: 5px") ✖
          span Закрыть
      .right_button_panel
        button.delete_button_panel(v-if="remove && removeText !== 'Подтвердить'" @click="checkRemoveState") {{removeText}}
        button.sure_delete_button_panel(v-if="remove && removeText === 'Подтвердить'" @click="removeState") {{removeText}}
</template>
<script>
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    'v-icon': Icon
  },
  props: ['save', 'close', 'closeWithOutChanges', 'remove'],
  data () {
    return {
      removeText: 'Удалить'
    }
  },
  methods: {
    saveState () {
      this.$parent.saveState()
    },
    closeState () {
      window.close()
      this.$parent.closeState()
    },
    checkRemoveState () {
      this.removeText = 'Подтвердить'
      setTimeout(() => {
        this.removeText = 'Удалить'
      }, 3000)
    },
    removeState () {
      this.$parent.removeState()
    }
  }
}
</script>
<style lang="sass" scoped>
.main_container_button_panel
  display: flex
  justify-content: center
  align-items: center
  height: 55px
  width: 100%
  background: #f7f7f0
  position: fixed
  bottom: 0
.btn_container_button_panel
  width: 1400px
  display: grid
  grid-template-columns: 70% 30%
.right_button_panel
  text-align: right
.left_button_panel
  margin: 0 auto 0 0
button
  outline: none
  font-family: 'Roboto'
  height: 35px
  min-width: 100px
  border: none
  font-size: 15px
  border-radius: 4px
  cursor: pointer
button:not(:first-child)
  margin-left: 5px
button:hover
  transition: all .3s
  filter: brightness(0.85)
.save_button_panel
  background: #035cc9
  color: white
.close_button_panel
  padding: 0 10px
  background: white
  border: 1px solid #ccc
.delete_button_panel
  transition: all .3s
  background: #e53935
  color: white
.sure_delete_button_panel
  transition: all .3s
  background: #871412
  color: white
</style>
